import {Component, Input, OnInit} from '@angular/core';

@Component({
    selector: 'app-modal-header',
    templateUrl: './modal-header.component.html',
    styleUrls: ['./modal-header.component.scss'],
    standalone: false
})
export class ModalHeaderComponent implements OnInit {

  @Input() title: string;
  @Input() showCoverPhoto = true;
  @Input() passwordChanged: boolean;

  constructor() { }

  ngOnInit(): void {
  }

}
